import { AssociatedUserType } from "@/utils/enum";
import {
  addUserToCompany,
  deleteUserFromEntityGroup,
  fetchAssociatedUsers,
  fetchAssociatedEntities,
} from "@/services/entityGroups";

const Model = {
  namespace: "entityUsers",
  state: {
    users: {
      items: [],
      totalCount: 0,
    },
    associatedUsers: {
      items: [],
      totalCount: 0,
    },
    groupAssociatedUsers: {
      items: [],
      totalCount: 0,
    },
  },
  effects: {
    *getAssociatedUsers({ entityId, page, pageSize }, { call, put }) {
      const response = yield call(fetchAssociatedUsers, entityId, page, pageSize);

      yield put({
        type: "setAssociatedUsersList",
        payload: response,
      });
    },
    *addUserToEntity({ entityId, userId, associateUserType }, { call }) {
      yield call(addUserToCompany, entityId, userId, associateUserType);
    },
    *removeUserFromEntity({ userId }, { call }) {
      try {
        yield call(deleteUserFromEntityGroup, userId);
        return true;
      } catch (error) {
        return false;
      }
    },
    *getAssociatedEntities({ userId, associateUserType, page, pageSize }, { call, put }) {
      const response = yield call(fetchAssociatedEntities, userId, associateUserType, page, pageSize);

      if (associateUserType === null || associateUserType === AssociatedUserType.Company) {
        yield put({
          type: "setAssociatedUsers",
          payload: response,
        });
      } else {
        yield put({
          type: "setGroupAssociatedUsers",
          payload: response,
        });
      }
    },
  },
  reducers: {
    setAssociatedUsersList(state, { payload }) {
      return {
        ...state,
        users: {
          items: payload?.items || [],
          totalCount: payload?.totalCount || 0,
        },
      };
    },
    setAssociatedUsers(state, { payload }) {
      return {
        ...state,
        associatedUsers: {
          items: payload?.items || [],
          totalCount: payload?.totalCount || 0,
        },
      };
    },
    setGroupAssociatedUsers(state, { payload }) {
      return {
        ...state,
        groupAssociatedUsers: {
          items: payload?.items || [],
          totalCount: payload?.totalCount || 0,
        },
      };
    },
  },
};

export default Model;
